import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-scale',
    templateUrl: './scale.component.svg',
    styleUrls: ['./scale.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScaleComponent {}
